/**
 * API client for internal-only routes on the claim-checking Edge Function.
 * Uses internalClaimsAPIClient (session JWT, no anon fallback) — these routes
 * require an authenticated internal user.
 */

import { internalClaimsAPIClient } from "./apiClients";
import type { ClaimVerificationTraceResponse } from "../types/claims";

export type { ClaimVerificationTraceResponse };

/** Fetch the verdict and full computation trace pinned to a specific user event. */
export async function fetchClaimVerificationTrace(
  userEventVerificationId: string
): Promise<ClaimVerificationTraceResponse> {
  const { data } = await internalClaimsAPIClient.get<ClaimVerificationTraceResponse>(
    `/verifications/${userEventVerificationId}/trace`
  );
  return data;
}
